<oui-document-viewer
  class="slide-panel-viewer"
  [documentUrl]="fileUrls()"
  [showControls]="true">
  @if (isLoading() && !(loadingService.isLoading$ | async)) {
    <div class="loading-container">
      <oui-loading></oui-loading>
    </div>
  }
  @if (displayFieldsToComplete()) {
    <div>
      <oui-etat-vide
        icon="restore_page"
        title="Des champs semblent manquer.">
      </oui-etat-vide>
      <oui-etat-vide title="Compléter et/ou actualiser vos informations pour voir le document."></oui-etat-vide>
    </div>
  } @else if (!isLoading() && !unsignedDocument()) {
    <oui-etat-vide
      icon="unknown_document"
      title="Erreur dans le chargement du DER"></oui-etat-vide>
  }

  <div
    class="document-controls"
    oui-document-controls>
    <div class="document-name-container">
      <div class="document-name">
        <div class="headline-6">Document d'Entrée en Relation</div>
      </div>
      <oui-button
        type="icon"
        color="secondary"
        (click)="closeSlidePanel()">
        <oui-icon>close</oui-icon>
      </oui-button>
    </div>

    @if (!isLoading()) {
      @if (!displayFieldsToComplete()) {
        @if (!(loadingService.isLoading$ | async)) {
          <span class="document-date body-2"
            >Dernière mise à jour le {{ $safeNavigationMigration(unsignedDocument()?.updatedDate) | date: 'dd/MM/yyyy à HH:mm' }}
          </span>

          <div class="document-file-actions">
            @if (showSendToSignature()) {
              <div
                [ouiTooltip]="signatureTooltip()"
                class="width-fill-available">
                <oui-button
                  class="width-fill-available"
                  iconPrefix="signature"
                  (click)="sendToSignature()"
                  [disabled]="signatureDisabled()">
                  Envoyer en signature
                </oui-button>
              </div>
            }
            @if (signedDocument()) {
              <oui-menu [menuItems]="downloadMenuItems">
                <oui-button
                  class="width-fill-available"
                  iconPrefix="download"
                  iconSuffix="arrow_drop_down"
                  type="outlined">
                  Télécharger le document
                </oui-button>
              </oui-menu>
            } @else {
              <oui-button
                class="width-fill-available"
                type="outlined"
                iconPrefix="download"
                (click)="downloadDocument(unsignedDocument())">
                Télécharger le document
              </oui-button>
            }
          </div>
        }

        @if (!isGestionPrivee()) {
          <oui-banner
            title="Informations à mettre à jour ?"
            type="complex"
            description="Vous pouvez corriger celles sur lesquelles vous avez la main dans MyProdémial, puis cliquer sur « Actualiser le document »."
            [action]="updateBannerAction"
            [showCloseButton]="false">
          </oui-banner>
        }
      }
      <oui-button
        class="width-fill-available"
        iconPrefix="cached"
        [type]="displayFieldsToComplete() ? 'contained' : 'outlined'"
        (click)="forceDERUpdate()">
        Actualiser le document
      </oui-button>

      @if (displayFieldsToComplete()) {
        @if (fieldsToCompleteProdemial()) {
          <oui-banner
            title="Champs manquants"
            type="complex"
            description="{{ fieldsToCompleteProdemial() }} dans vos données d'habilitation.
            Vous pouvez mettre à jour ces données sur votre plateforme MyProdémial."
            [action]="updateBannerAction"
            declination="error"
            [showCloseButton]="false">
          </oui-banner>
        }

        @if (fieldsToCompleteSHM()) {
          <oui-banner
            title="Champs manquants"
            type="complex"
            description="{{ fieldsToCompleteSHM() }}"
            [action]="shmBannerAction"
            declination="error"
            [showCloseButton]="false">
          </oui-banner>
        }
      }
    }
  </div>
</oui-document-viewer>
